import React from 'react';
import { APP_VERSION } from '../config/version';
import './VersionPage.css';

function VersionPage() {
  return (
    <div className="version-page">
      <div className="version-page__card">
        <h1 className="version-page__title">Version</h1>
        <p className="version-page__version">{APP_VERSION}</p>
        <p className="version-page__subtitle">Currently running on your device</p>
        <a href="/" className="version-page__back">
          Back to App
        </a>
      </div>
    </div>
  );
}

export default VersionPage;
